import React, {Component} from 'react';
import logo from '../../img/s-v-t.svg';
import {connect} from "react-redux";

class ClosedPage extends Component {
    render() {
        return (
            <div className="App">
                <div className="App-header">
                    <h1>
                        <img src={logo} className="App-logo" alt="logo"/>
                    </h1>
                </div>

                <div className="TextArea">
                    <h1>Hej och välkommen till SVTs andra videokvalitetstest</h1>

                    <p>
                        Testet är nu avslutat, tack till alla som har medverkat!
                    </p>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ClosedPage);



// WEBPACK FOOTER //
// ./src/components/ClosedPage/ClosedPage.js